// A file attached to a message draft (crm.communication.attachments) lives in the archive container at
// `communication-files/<sha256>`, never in Postgres (13 October 2026). Jacky, after the database froze twice on
// 12 October with every PDF stored inline as base64: "foundational PDF shouldn't be stored in DB".
//
// The path is the content's own sha256, so the same file is kept once however many drafts carry it, and a blob
// can never be swapped under a reference: the backbone (save_communication, delivery claim) and the API (the
// propose relay, attachment reads, the archive) all derive and check the path from here.
export const COMMUNICATION_FILE_PREFIX = "communication-files/";
const SHA256 = /^[0-9a-f]{64}$/;
export function communicationFilePath(sha256) {
    if (!SHA256.test(sha256))
        throw new Error("A communication file path needs a lowercase sha256");
    return `${COMMUNICATION_FILE_PREFIX}${sha256}`;
}
/** A file a proposal hands over inline (e.g. record_job_document's PDF) is kept at `case-files/<sha256>` before the
 *  case is recorded, so bb.action.args holds a reference, never the bytes (13 October 2026). */
export const CASE_FILE_PREFIX = "case-files/";
export function caseFilePath(sha256) {
    if (!SHA256.test(sha256))
        throw new Error("A case file path needs a lowercase sha256");
    return `${CASE_FILE_PREFIX}${sha256}`;
}
export function isCaseFilePath(path, sha256) {
    return SHA256.test(sha256) && path === `${CASE_FILE_PREFIX}${sha256}`;
}
/** True only for the one path a file with this sha256 may live at. */
export function isCommunicationFilePath(path, sha256) {
    return SHA256.test(sha256) && path === `${COMMUNICATION_FILE_PREFIX}${sha256}`;
}
/** MAIL ATTACHMENT CEILINGS, one place for every door onto the mailbox (26 October 2026). Until now 2 MB per file and
 *  5 MB per message were typed into fourteen places, and nobody could say why — the delivery side, EmmA's mail worker
 *  (emma-hub `customerCommunicationWorker.ts`, MAX_ATTACHMENT_BYTES / MAX_TOTAL_BYTES), already allowed 3 MB and 10 MB.
 *  3 MB per file is Microsoft Graph's limit for a plain attachment (larger needs an upload session the worker does not
 *  have); 10 MB per message is our own ceiling, under what most receivers reject. These must never exceed the worker's
 *  numbers, or a draft is saved here and fails at delivery. */
export const MAX_MAIL_ATTACHMENT_BYTES = 3 * 1024 * 1024;
export const MAX_MAIL_MESSAGE_BYTES = 10 * 1024 * 1024;
export const MAX_MAIL_ATTACHMENT_MB = 3;
export const MAX_MAIL_MESSAGE_MB = 10;
/** The base64 text of a file at the per-file ceiling (4/3 of the bytes, plus padding). */
export const MAX_MAIL_ATTACHMENT_BASE64_CHARS = Math.ceil(MAX_MAIL_ATTACHMENT_BYTES / 3) * 4;
//# sourceMappingURL=communication-file.js.map